import React from 'react';
import '../../ProductBase.css';
import './index.css';
import { useNavigate } from 'react-router-dom';
import { getMainProductImage, getProductTypeDisplayName } from '../../utils/productUtils';
import { getProductsByType } from '../../services/productService';
import { ProductType } from '../../context/CartContext';

const products = getProductsByType(ProductType.SPORTS);

const ShopSports: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="shop-container">
      <div className="products-grid">
        {products.map((product) => (
          <div key={product.id} className="product-card">
            <h2 className="product-name">
              {product.name}
            </h2>
            <div className="product-image-wrapper">
              <img 
                src={getMainProductImage(product)} 
                alt={product.name} 
                className="product-image" 
                onClick={() => navigate(`/product/${product.id}`)}
              />
            </div>
            <div className="product-info">
              <div className="product-actions">
                <button onClick={() => navigate(`/product/${product.id}`)} className='detail-button'>
                  Customize
                </button>
              </div>
             
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShopSports;
